export const AppRuntime = {
  get origin(): string {
    return window.location.origin;
  },

  get hostname(): string {
    return window.location.hostname;
  },

  // Returns true if the URL explicitly mentions rewards OR if you're testing it locally
  get isRewardsHost(): boolean {
    return this.hostname.includes('rewards') || (this.hostname === 'localhost' && sessionStorage.getItem('test_mode') === 'rewards');
  },

  get isWalletHost(): boolean {
    return this.hostname.includes('wallet') || (this.hostname === 'localhost' && !this.hostname.includes('rewards'));
  }
};